import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import { X } from 'react-feather';
import { FormattedMessage, intlShape } from 'react-intl';
import Button from 'primitives/other/button';
import FlexContainer from 'primitives/container/flex-container';
import Label from 'primitives/form/label';
import Input from 'primitives/form/input';
import './style.scss';

export default class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = { signup: props.registrationOpen };
  }
  onEditText = ({ target }) => this.props.updateUserForm(target.dataset.key, target.value);
  renderField(key, label, type = 'text') {
    return <div><Label htmlFor={key}>{label}</Label><Input id={key} name={key} data-key={key} type={type} value={this.props[key]} onChange={this.onEditText} /></div>;
  }
  render() {
    const { signup } = this.state;
    const { isLoginModalOpen, closeLoginModal, registrationOpen, error } = this.props;
    return <ReactModal contentLabel="Signup & Login" isOpen={isLoginModalOpen} onCancel={closeLoginModal} className="LoginModal" overlayClassName="LoginModal-Overlay" ariaHideApp={false}>
      <X className="LoginModal-Close" onClick={closeLoginModal} size={30} />
      {registrationOpen && <FlexContainer className="LoginModal-Switcher" justify="center">
        <button type="button" onClick={() => this.setState({ signup: false })} className={classNames('LoginModal-SwitchButton', { 'LoginModal-SwitchButton--active': !signup })}><FormattedMessage id="misc.logIn" /></button>
        <button type="button" onClick={() => this.setState({ signup: true })} className={classNames('LoginModal-SwitchButton', { 'LoginModal-SwitchButton--active': signup })}><FormattedMessage id="misc.signUp" /></button>
      </FlexContainer>}
      <FlexContainer className="LoginModal-FormContainer" justify="center" direction="column">
        {this.renderField('username', 'Username')}
        {signup && this.renderField('displayName', 'Display name')}
        {this.renderField('password', <FormattedMessage id="misc.password" />, 'password')}
        {signup && this.renderField('confirm', <FormattedMessage id="misc.confirm" />, 'password')}
        {error && <FlexContainer className="LoginModal-Error" justify="center">{error}</FlexContainer>}
        <FlexContainer className="LoginModal-Submit" justify="center"><Button primary onClick={signup ? this.props.signup : this.props.login}>{signup ? <FormattedMessage id="misc.signUp" /> : <FormattedMessage id="misc.logIn" />}</Button></FlexContainer>
      </FlexContainer>
    </ReactModal>;
  }
}
LoginModal.propTypes = {
  isLoginModalOpen: PropTypes.bool.isRequired, registrationOpen: PropTypes.bool.isRequired,
  closeLoginModal: PropTypes.func.isRequired, updateUserForm: PropTypes.func.isRequired,
  signup: PropTypes.func.isRequired, login: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired, displayName: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired, confirm: PropTypes.string.isRequired,
  error: PropTypes.string, intl: intlShape.isRequired,
};
LoginModal.defaultProps = { error: null };
